import React from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import styles from "./deleteaccount.module.scss";

class DeleteAccount extends React.Component {
  render() {
    return (
      <div>
        <Header/>

        <div className={styles.inrBannerSec}>
          <div className={styles.inrBnrImg}>
            <img alt="" src={"../../images/inner-about-banner.jpg"} />
          </div>
          <div className={styles.inrBnrCap}>
            <div className={styles.container}>
              <h1>Delete <span>Account</span></h1>
            </div>
          </div>
        </div>

        <div className={`${styles.privacyPolicyBodySec} ${styles.pb500}`}>
          <div className={styles.container}>
            <h2>How to delete your Drywall Genie account</h2>
            <p>You can delete your Drywall Genie account and all associated data directly from the app:</p>
            <ol>
              <li>Open the Drywall Genie app and log in.</li>
              <li>Go to <strong>Settings</strong>.</li>
              <li>Tap <strong>Delete Account</strong>.</li>
              <li>Confirm the deletion when prompted.</li>
            </ol>
            <p>If you no longer have the app installed, you can request deletion instead by emailing <a href="mailto:drywallgenieapp@gmail.com">drywallgenieapp@gmail.com</a> from the email address associated with your account. Include your name and, if possible, the company/contractor name on your account so we can locate it. We will confirm once the deletion is complete.</p>

            <h2>What gets deleted</h2>
            <p>Deleting your account permanently removes:</p>
            <ul>
              <li>Your name, email address, and profile information</li>
              <li>Your saved jobs, job areas, and associated job data</li>
              <li>Your sign-in association with Google or Apple</li>
            </ul>

            <h2>Timing</h2>
            <p>Deletion is immediate and permanent, whether requested in-app or by email. We do not retain a copy of your account or job data afterward.</p>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
export default DeleteAccount;
